module.exports = __webpack_public_path__ + "static/media/gmp.a9b4bdce.png";